<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{ aLang.c_create }} nguồn bài viết</span>
        <span v-if="mData.viewMode == 'update'">{{ aLang.c_update }} nguồn bài viết</span>
        <span v-if="mData.viewMode == 'detail'">{{ aLang.c_detail }} nguồn bài viết</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm" label-width="100%" label-position="top">
          <b-row>
            <b-col md="6">
              <el-form-item label="Tên nguồn" prop="ten">
                <el-input v-model="mData.dataForm.ten" :disabled="mData.viewMode == 'detail'" clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Hiển thị" prop="hien_thi" class="label-required">
                <el-select v-model="mData.dataForm.hien_thi" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listVisible" :key="item.code" :label="item.label"
                    :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button type="info" plain @click="fn_submitForm('create')" v-ladda
              v-if="mData.viewMode == 'create'">{{ aLang.c_create }}</el-button>

            <el-button type="info" plain @click="fn_submitForm('update')" v-ladda
              v-if="mData.viewMode == 'update'">{{ aLang.c_update }}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{ aLang.c_back }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from '../../../service/LanguageService';
import MethodService from '../../../service/MethodService';
import NguonTinTucModel from '@/views/admin/NguonTinTuc/NguonTinTucModel';
import NguonBaiVietApi from '@/moduleApi/NguonBaiVietApi';

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      aRole: MethodService.checkRole,
      mData: {
        viewMode: "create",
        moduleName: "NguonTinTuc",
        dataDefault: {
          listVisible: [
            {
              code: true,
              label: "Hiển thị"
            },
            {
              code: false,
              label: "Ẩn"
            }
          ],
          tourTimeErrorMessage: false
        },
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
        dataForm: {},
        fileUploadOption: MethodService.copyObject(
          NguonTinTucModel.dataFormOther.fileUploadOption
        ),
        validForm: NguonTinTucModel.validForm
      }
    };
  },
  async mounted() {

  },
  async created() {
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-create"
    ) {
      this.mData.viewMode = "create";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
      if (this.$router.currentRoute.params.id) {
        this.fn_getDataById(this.$router.currentRoute.params.id);
      }
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
      if (this.$router.currentRoute.params.id) {
        this.fn_getDataById(this.$router.currentRoute.params.id);
      }
    }

  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          if (type === "create") {
            await NguonBaiVietApi.create(data);
            this.fn_go();
            this.fn_resetForm();
          }
          if (type === "update") {
            data.id = this.$router.currentRoute.params.id;
            await NguonBaiVietApi.update(data);
            this.fn_go();
            this.fn_resetForm();
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(
        NguonTinTucModel.dataForm
      );

      this.$refs["myForm"].resetFields();
    },

    async fn_getDataById(id) {
      let nguonTinTucRes = await NguonBaiVietApi.findById(id);
      if (nguonTinTucRes.result) {
        let resData = await this.fn_changeData(nguonTinTucRes.result);
        this.mData.dataForm = resData;
      }
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      return resData;
    },

    fn_go() {
      this.$router.go(-1);
    },
    handleBlur(prop) {
      this.$refs["myForm"].validateField(prop);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    }
  }
}
</script>
<style>
@media (min-width: 1220px) {
  .col-custom {
    max-width: 20%;
  }
}
</style>
